import { api } from '@fno/service/global.js'
import { writable } from 'svelte/store'
import createCache from '@fno/lib/create-cache.js'
import { get } from 'lodash'
import getTABRoutes from '@fno/route/tab/step-id-to-route'

export const currentSchool = writable(null)

const selectedSchoolCache = createCache()

export const getSchool = ({ schoolId, include = [] }) => selectedSchoolCache(
    () => api
        .get(`/v2/schools/${schoolId}${include.length ? `?include=${include.join(",")}` : ''}`)
        .then(response => {
            const school = get(response, 'data')
            const orgsData = get(response, 'included[0].orgs.fields', {})

            const lightVersionApp = get(school, 'attributes.lightVersionApp') && !get(school, 'attributes.isSMAPremium')
            const smaPremiumVersionApp = get(school, 'attributes.lightVersionApp') && get(school, 'attributes.isSMAPremium')
            const schoolTier = lightVersionApp
                ? 'tier1'
                : smaPremiumVersionApp
                    ? 'tier2'
                    : 'tier3'

            const schoolData = {
                school,
                tier: schoolTier,
                stepIdToRoute: getTABRoutes(schoolTier),
                orgsData
            }

            currentSchool.set(schoolData)

            return schoolData
        })
        .then((data) => {
            if (data.tier === 'tier1') {
                window.location.replace(`${window.origin}/app#/app/school/${data.school.id}`)
            }

            return data
        })
)

export const patchSchool = ({ school }) => api
    .patch(`/v2/schools/${school.id}`, {
        data: school
    })
    .then(response => response.data)
